import { defineComponent as _defineComponent } from 'vue'
import type { Area, Category } from '@ilteducation/content-ref-data-types';
import { ref } from 'vue';
import { getAllRefData } from '@/data-provider/refDataProvider';

type Props = {
  id: string;
  title: string;
  item: Area;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'Show',
  props: {
    id: null,
    title: null,
    item: null
  },
  setup(__props: any) {

const props = __props as {
  id: string;
  title: string;
  item: Area;
}



const areaGuideUrl = ref('');
getAllRefData('categories')
  .then((categories) => categories.find((c: Category) => c.id === props.item.categoryId))
  .then((category: Category) => {
    const environment = process.env.VUE_APP_ENVIRONMENT;
    const market = category.realms![0];
    areaGuideUrl.value = `https://${environment === 'production' ? 'app' : 'app-dev'}.${
      market === 'se' ? 'begreppa' : 'manabua'
    }.${market}/videos/${category.slug}/${props.item.slug}`;
  });

return { __sfc: true,props, areaGuideUrl }
}

})